export const FETCHED_PRODUCT_CATEGORIES = 'FETCHED_PRODUCT_CATEGORIES';
export const FETCHED_ARTICLE_CATEGORIES = 'FETCHED_ARTICLE_CATEGORIES';
export const FETCHED_ALL_PAGES = 'FETCHED_ALL_PAGES';
export const FETCHED_USER_INFO = 'FETCHED_USER_INFO';
export const USER_FROM_CAMPAIGN = 'USER_FROM_CAMPAIGN';
export const USER_FROM_LOTTERY = 'USER_FROM_LOTTERY';
export const FETCHED_USER_DATA = 'FETCHED_USER_DATA';
